import { Action } from "redux";
import { LoadClinicInformationAction } from "../ClinicInformation/type";
import {
    RESET_ACQUIRE_METHODE_DATA,
    TOGGLE_POSTAL_CODE_CONFIRMATION_MODAL,
    TOGGLE_VALIDATION_MESSAGE_VISIBILITY,
    INCREMENT_NUMBER_OF_ATTEMPTS,
    CHANGE_BUTTON_SUBMIT_STATUS,
    CHANGE_VERIFICATION_POSTAL_CODE,
    CHANGE_HEALTH_CARD_NUMBER,
    SELECT_HEALTHCARD_NUMBER_ACQUIRING_METHOD,
    CHANGE_MASK_LOCATION
} from "./constants";

/**
 * @name ACQUIRING_MODE
 * @description
 *      -MANUAL: Manual entry of health card number,
 *      -SCANNER: Entry of health card number using barcode scanner.
 *      -NONE: Default value, when method is not selected
 * @export
 * @enum {number}
 */
export enum ACQUIRING_MODE {
    MANUAL,
    SCANNER,
    NONE
};


/**
 * @name AcquireHealthCardNumberState
 * @export
 */
export interface AcquireHealthCardNumberState {
    acquiringMode: ACQUIRING_MODE,              // Method of acquiring health card number
    isSubmitButtonActive: boolean,              // Is manual health card input submit button disabled or not.
    healthCardNumber: string,                   // The actual health card number entered/received.
    postalCodeEntered: string,                  // The actual postal code/zipcode entered for verification.
    healthCardNumberOfAttempts: number,         // Number of times the user submitted / scanned health card number.
    invalidHealthCardNumberDetected: boolean,   // Boolean used to indicate that the server received an invalid health card number
    invalidPostalCodeDetected: boolean,         // Boolean used to indicate that the server received an invalid postal code or zipcode.
    showCreateNewPatientModal: boolean,         // Boolean used to show or hide a popup that will indicate that the use will now be creating a profile.
    showPostalCodeConfirmationModal: boolean,   // Boolean used to show or hide the postal code / zip code verification popup.
    postalCodeNumberOfAttempts: number,         // Number of times the user submitted the verification postal code.
    maskCountry: string,
    maskRegion: string,

}

// Define actions interfaces
export interface SelectHealthCardAcquiringModeAction extends Action {
    type: SELECT_HEALTHCARD_NUMBER_ACQUIRING_METHOD;
    payload: {
        method: ACQUIRING_MODE;
    };
}

export interface ChangeHealthCardNumberAction extends Action {
    type: CHANGE_HEALTH_CARD_NUMBER;
    payload: {
        healthCardNumber: string;
    };
}

export interface ChangeValidationPostalCodeValueAction extends Action {
    type: CHANGE_VERIFICATION_POSTAL_CODE;
    payload: {
        postalCode: string;
    };
}

export interface SubmitButtonDisabledStatusAction extends Action {
    type: CHANGE_BUTTON_SUBMIT_STATUS;
    payload: {
        isSubmitButtonActive: boolean;
    };
}

export interface IncrementNumberOfSubmitAttemptsAction extends Action {
    type: INCREMENT_NUMBER_OF_ATTEMPTS,
    payload: {
        fieldType: string
    }
}

export interface ToggleValidationMessageVisibilityAction extends Action {
    type: TOGGLE_VALIDATION_MESSAGE_VISIBILITY,
    payload: {
        isValidationMessageVisible: boolean,
        fieldType: string
    }
}

export interface ToggleShowPostalCodeConfirmationModalAction extends Action {
    type: TOGGLE_POSTAL_CODE_CONFIRMATION_MODAL,
    payload: {
        showPostalCodeModal: boolean
    }
}

export interface ResetAcquireMethodDataAction extends Action {
    type: RESET_ACQUIRE_METHODE_DATA
}
export interface ChangeHealthCardMaskLocationAction extends Action {
    type: CHANGE_MASK_LOCATION,
    payload: {
        country: string,
        region: string
    }
}


export type AcquireHealthCardNumberAction =
    ResetAcquireMethodDataAction |
    SelectHealthCardAcquiringModeAction |
    ChangeHealthCardNumberAction |
    SubmitButtonDisabledStatusAction |
    IncrementNumberOfSubmitAttemptsAction |
    ToggleValidationMessageVisibilityAction |
    ChangeValidationPostalCodeValueAction |
    ToggleShowPostalCodeConfirmationModalAction |
    ChangeHealthCardMaskLocationAction |
    LoadClinicInformationAction;


// WEBPACK FOOTER //
// ./src/store/AcquireHealthCardNumber/type.ts